import containerFuild from '../html-snippets/container-fuild.js';
import css from '../tpl-css/style-section-cefloreco-product-world.js';

const html = `
<div
  data-use-custom-width="true"
  data-custom-width="1204"
  class="container"
  data-attribute="container-content"
  style="--custom-width: 1204px;"
>
  <div class="header-card">
    <div class="title-card" data-attribute="title-card">
      <p style="color: #ff7657">Our product universe</p>
      <h2>
        One studio. <br />
        Many everyday <br />
        experiences.
      </h2>
    </div>
    <div class="desc-card" data-attribute="desc-card">
      <p>
        From entertainment and creativity to learning and utility, we build digital products that become part of
        people's everyday lives.
      </p>
    </div>
  </div>
  <div class="img-preview" data-attribute="img-preview">
    <img
      data-attribute="img-preview-image"
      src="https://cdn.skyfastimg.com/images/2026/10/26/image-6adf2b900c068776ab7f333e.webp?w=1920&q=100"
      alt=""
    />
  </div>
  <div
    class="list-fetures"
    data-attribute="list-fetures"
    data-color-border-item="#bebebe"
    data-color-highlight-item="#ff7657"
    style="--color-border-item: #bebebe; --color-highlight-item: #ff7657;"
  >
    <div class="item-feture" data-attribute="item-freture">
      <div class="stt-item" data-attribute="stt-item">01</div>
      <div class="content-item" data-attribute="content-item">
        <h4>Product Strategy</h4>
        <p>Turning ideas and user insights into products built for real market opportunities.</p>
      </div>
    </div>

    <div class="item-feture" data-attribute="item-freture">
      <div class="stt-item" data-attribute="stt-item">02</div>
      <div class="content-item" data-attribute="content-item">
        <h4>Product Strategy</h4>
        <p>Turning ideas and user insights into products built for real market opportunities.</p>
      </div>
    </div>

    <div class="item-feture" data-attribute="item-freture">
      <div class="stt-item" data-attribute="stt-item">03</div>
      <div class="content-item" data-attribute="content-item">
        <h4>Product Strategy</h4>
        <p>Turning ideas and user insights into products built for real market opportunities.</p>
      </div>
    </div>
  </div>
</div>
`;

export default containerFuild(html, css, {
  backgroundColor: '#000',
  textColor: '#fff',
  backgroundImage: 'https://cdn.skyfastimg.com/images/2026/10/26/image-6adf2ede459e6b297f614c47.webp?w=1920',
  topPadding: true,
  bottomPadding: true,
});
